import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HighlightSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            用专业和温度，守护每一段关系
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            我们相信，每一段亲密关系都值得被认真对待
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              icon: 'ri-shield-check-line',
              color: 'primary',
              title: '专业可信',
              desc: '所有内容由注册心理咨询师、三甲医院医师、资深婚姻家庭咨询师撰写或审核，确保信息的科学性和权威性。',
            },
            {
              icon: 'ri-heart-3-line',
              color: 'accent',
              title: '温暖共情',
              desc: '我们理解每段关系都有其独特性。不批判、不说教，用温暖而尊重的态度陪伴每一位读者成长。',
            },
            {
              icon: 'ri-book-open-line',
              color: 'secondary',
              title: '全面系统',
              desc: '从情感连接到性健康，从婚姻经营到亲子关系，六大分类覆盖亲密关系的全维度，提供系统化的知识体系。',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-lg border border-background-200/70 p-8 text-center hover:border-primary-200 transition-colors"
            >
              <div
                className={`w-14 h-14 mx-auto mb-5 rounded-full bg-${item.color}-100 flex items-center justify-center`}
              >
                <i className={`${item.icon} text-2xl text-${item.color}-500`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-6 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100/70 hover:bg-background-200/70 transition-colors"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50">
                <i className={`${cat.icon} text-lg text-primary-500`}></i>
              </span>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}